// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-project-project-logo-work----project-logo-work-module---wrapper---1wZvJ","logos":"src-components-project-project-logo-work----project-logo-work-module---logos---10NMQ","inner":"src-components-project-project-logo-work----project-logo-work-module---inner---2Dw_9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/project/project-logo-work/project-logo-work.module.css
// module id = 524
// module chunks = 140935043865547